/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react';

interface IMessage<T> {
  data: T;
  topic: string;
}
interface IPostToTabState<T> {
  window: IWindow<T>;
  data?: T;
}
interface IWindow<T> {
  postMessage: (message: IMessage<T>) => void;
}

/**
 * Sendt data to a tab
 *
 * @param onMessageRecieved - Event should only be used in the reciecing window
 * @param key - unique key. Must be the same for the posting and recieving page
 * @returns postMessage - Post data to the opened tab
 */
export function usePostToTab<T>(key: string, onMessageRecieved?: (data: T) => void) {
  const [options, _setOptions] = useState<IPostToTabState<T>>();
  const optionsRef = useRef(options);
  const onMessageRecievedRef = useRef(onMessageRecieved);
  const setOptions = (d: IPostToTabState<T>) => {
    optionsRef.current = d;
    _setOptions(d);
  };

  // Update the ref whenever the callback changes
  onMessageRecievedRef.current = onMessageRecieved;

  useEffect(() => {
    if (onMessageRecieved) {
      window.addEventListener('message', receiveMessage, false);
      if (window.opener) {
        window.opener.postMessage({ topic: `${key}_Ready` } as IMessage<T>);
      }
    } else {
      window.addEventListener('message', isReady, false);
    }
  }, []);

  function isReady(event: MessageEvent) {
    if (event.data.topic === `${key}_Ready`) {
      optionsRef.current?.window.postMessage({ data: optionsRef.current?.data, topic: `${key}_Topic` } as IMessage<T>);
    }
  }
  function postData(destWindow: any, data?: T) {
    if (!destWindow) {
      return;
    }
    destWindow.postMessage({ data, topic: `${key}_Topic` } as IMessage<T>);
    setOptions({ data, window: destWindow });
  }
  function receiveMessage(event: MessageEvent) {
    if (event.data.topic === `${key}_Topic`) {
      onMessageRecievedRef.current && onMessageRecievedRef.current(event.data.data);
    }
  }
  return postData;
}
